import { FEATURE } from "../../../consts/Common";
import { GALLERY_SCHEMA } from "../../../consts/Template";
import Configs from "../../../Configurations";
import imgPlaceholderHero from "../../images/img-placeholder-hero.svg";
import imgPlaceholderArticle from "../../images/img-placeholder-article.svg";
import imgPlaceholderFeature from "../../images/img-placeholder-feature.svg";

const blob_url = Configs?.REACT_APP_IMAGE_STORAGE_URL || "https://blob.sparknotifications.walmart.com";

const General = {
  [GALLERY_SCHEMA.ID]: "comms_scoop",
  [GALLERY_SCHEMA.NAME]: "Scoop",
  [GALLERY_SCHEMA.CATEGORY]: FEATURE.COMMS_TEMPLATES,
  template_content: `<mjml>
  <mj-head>
    <mj-style>
      p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
      ul, ol { margin-block-start:0; margin-block-end:0; padding-block-start:0; padding-block-end:0; Margin:0; }
      a { color: inherit !important; text-decoration: underline; }
      @media only screen and (max-width:479px) {
        .mobile-stack-gap { padding-bottom: 24px !important; }
        .mobile-no-left-pad td { padding-left: 0px !important; }
        .mobile-img-no-pad table table { width: 100% !important; }
        .mobile-img-no-pad table td { width: 100% !important; }
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#F3F3F3">

    <!-- Header -->
    <mj-section
      padding-top="32px"
      padding-bottom="32px"
      padding-left="24px"
      padding-right="24px"
      background-color="#0053E2">
      <mj-column width="36%" vertical-align="middle" css-class="mobile-stack-gap">
        <mj-image
          src="${blob_url}/templateeditortestteam-image/WMT-Wordmark-Standard-White-RGB.png"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
      </mj-column>
      <mj-column width="64%" vertical-align="middle" css-class="mobile-no-left-pad">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="24px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><span style="font-size:18px"><span style="color:#ffffff">Official headlines from the Home Office</span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Hero Image -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="0px"
      padding-right="0px"
      background-color="#ffffff">
      <mj-column>
        <mj-image
          src="${imgPlaceholderHero}"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
      </mj-column>
    </mj-section>

    <!-- Feature Article -->
    <mj-section
      padding-top="32px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="16px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.4">
          <p><strong><span style="font-size:20px"><span style="color:#2E2F32">Headline Goes Here</span></span></strong></p>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="16px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eu feugiat pretium nibh ipsum consequat nisl vel pretium. Dignissim enim sit amet venenatis urna cursus.</span></span></p>
        </mj-text>
        <mj-button
          padding-top="0px"
          padding-bottom="24px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="14px"
          background-color="#0053E2"
          border-radius="1000px"
          width="105px"
          height="32px"
          inner-padding="5px 16px"
          font-weight="bold"
          align="left"
          font-style="normal">
          Read more
        </mj-button>
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          border-color="#E3E4E5">
        </mj-divider>
      </mj-column>
    </mj-section>

    <!-- Article Row 1 -->
    <mj-section
      padding-top="24px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="29%" css-class="mobile-stack-gap mobile-img-no-pad">
        <mj-image
          src="${imgPlaceholderArticle}"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
      </mj-column>
      <mj-column width="71%" css-class="mobile-no-left-pad">
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="24px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.4">
          <p><strong><span style="font-size:18px"><span style="color:#2E2F32">Section heading goes here</span></span></strong></p>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="24px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></span></p>
        </mj-text>
        <mj-button
          padding-top="0px"
          padding-bottom="19px"
          padding-left="24px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="14px"
          background-color="#0053E2"
          border-radius="1000px"
          width="105px"
          height="32px"
          inner-padding="5px 16px"
          font-weight="bold"
          align="left"
          font-style="normal">
          Read more
        </mj-button>
      </mj-column>
    </mj-section>

    <!-- Article Row 2 -->
    <mj-section
      padding-top="24px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="29%" css-class="mobile-stack-gap mobile-img-no-pad">
        <mj-image
          src="${imgPlaceholderArticle}"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
      </mj-column>
      <mj-column width="71%" css-class="mobile-no-left-pad">
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="24px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.4">
          <p><strong><span style="font-size:18px"><span style="color:#2E2F32">Section heading goes here</span></span></strong></p>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="24px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></span></p>
        </mj-text>
        <mj-button
          padding-top="0px"
          padding-bottom="19px"
          padding-left="24px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="14px"
          background-color="#0053E2"
          border-radius="1000px"
          width="105px"
          height="32px"
          inner-padding="5px 16px"
          font-weight="bold"
          align="left"
          font-style="normal">
          Read more
        </mj-button>
      </mj-column>
    </mj-section>

    <!-- Article Row 3 -->
    <mj-section
      padding-top="24px"
      padding-bottom="24px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="29%" css-class="mobile-stack-gap mobile-img-no-pad">
        <mj-image
          src="${imgPlaceholderArticle}"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
      </mj-column>
      <mj-column width="71%" css-class="mobile-no-left-pad">
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="24px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.4">
          <p><strong><span style="font-size:18px"><span style="color:#2E2F32">Section heading goes here</span></span></strong></p>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="24px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></span></p>
        </mj-text>
        <mj-button
          padding-top="0px"
          padding-bottom="19px"
          padding-left="24px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="14px"
          background-color="#0053E2"
          border-radius="1000px"
          width="105px"
          height="32px"
          inner-padding="5px 16px"
          font-weight="bold"
          align="left"
          font-style="normal">
          Read more
        </mj-button>
      </mj-column>
    </mj-section>

    <!-- Blue Feature -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="0px"
      padding-right="0px"
      background-color="#0053E2">
      <mj-column width="31%" vertical-align="middle" background-color="#0053E2" css-class="mobile-img-no-pad">
        <mj-image
          src="${imgPlaceholderFeature}"
          container-background-color="#0053E2"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
      </mj-column>
      <mj-column width="69%" vertical-align="middle">
        <mj-text
          padding-top="24px"
          padding-bottom="8px"
          padding-left="24px"
          padding-right="24px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.4">
          <p><strong><span style="font-size:18px"><span style="color:#ffffff">Section heading goes here</span></span></strong></p>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="24px"
          padding-left="24px"
          padding-right="24px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#ffffff">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- White Gap -->
    <mj-section
      padding-top="24px"
      padding-bottom="0px"
      padding-left="0px"
      padding-right="0px"
      background-color="#ffffff">
      <mj-column>
      </mj-column>
    </mj-section>

    <!-- In the News -->
    <mj-section
      padding-top="24px"
      padding-bottom="24px"
      padding-left="24px"
      padding-right="24px"
      background-color="#E9F1FE">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><strong><span style="font-size:18px"><span style="color:#2E2F32">In the News</span></span></strong></p>
          <ul>
            <li><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</span></span></li>
            <li><span style="font-size:16px"><span style="color:#2E2F32">Accumsan sit amet nulla facilisi morbi.</span></span></li>
            <li><span style="font-size:16px"><span style="color:#2E2F32">Nisi vitae suscipit tellus mauris a diam maecenas sed.</span></span></li>
          </ul>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Upcoming Events Title -->
    <mj-section
      padding-top="32px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.4">
          <p style="text-align:center"><strong><span style="font-size:20px"><span style="color:#2E2F32">Upcoming Events</span></span></strong></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Event Divider 1 -->
    <mj-section
      padding-top="16px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          border-color="#E3E4E5">
        </mj-divider>
      </mj-column>
    </mj-section>

    <!-- Event Row 1 -->
    <mj-section
      padding-top="16px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="25%" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><strong><span style="font-size:16px"><span style="color:#2E2F32">Date</span></span></strong></p>
          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32">Time</span></span></p>
        </mj-text>
      </mj-column>
      <mj-column width="48%" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><strong><span style="font-size:16px"><span style="color:#2E2F32">Event name</span></span></strong></p>
          <p><span style="font-size:14px"><span style="color:#2E2F32">Event location</span></span></p>
        </mj-text>
      </mj-column>
      <mj-column width="27%" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:right"><span style="font-size:16px"><span style="color:#2E2F32"><u>Interested &gt;</u></span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Event Divider 2 -->
    <mj-section
      padding-top="16px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          border-color="#E3E4E5">
        </mj-divider>
      </mj-column>
    </mj-section>

    <!-- Event Row 2 -->
    <mj-section
      padding-top="16px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="25%" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><strong><span style="font-size:16px"><span style="color:#2E2F32">Date</span></span></strong></p>
          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32">Time</span></span></p>
        </mj-text>
      </mj-column>
      <mj-column width="48%" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><strong><span style="font-size:16px"><span style="color:#2E2F32">Event name</span></span></strong></p>
          <p><span style="font-size:14px"><span style="color:#2E2F32">Event location</span></span></p>
        </mj-text>
      </mj-column>
      <mj-column width="27%" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:right"><span style="font-size:16px"><span style="color:#2E2F32"><u>Interested &gt;</u></span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Event Divider 3 -->
    <mj-section
      padding-top="16px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          border-color="#E3E4E5">
        </mj-divider>
      </mj-column>
    </mj-section>

    <!-- Event Row 3 -->
    <mj-section
      padding-top="16px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="25%" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><strong><span style="font-size:16px"><span style="color:#2E2F32">Date</span></span></strong></p>
          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32">Time</span></span></p>
        </mj-text>
      </mj-column>
      <mj-column width="48%" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><strong><span style="font-size:16px"><span style="color:#2E2F32">Event name</span></span></strong></p>
          <p><span style="font-size:14px"><span style="color:#2E2F32">Event location</span></span></p>
        </mj-text>
      </mj-column>
      <mj-column width="27%" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:right"><span style="font-size:16px"><span style="color:#2E2F32"><u>Interested &gt;</u></span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Event Divider 4 -->
    <mj-section
      padding-top="16px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          border-color="#E3E4E5">
        </mj-divider>
      </mj-column>
    </mj-section>

    <!-- More Events -->
    <mj-section
      padding-top="24px"
      padding-bottom="24px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-button
          padding-top="0px"
          padding-bottom="16px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="14px"
          background-color="#0053E2"
          border-radius="1000px"
          width="105px"
          height="32px"
          inner-padding="5px 16px"
          font-weight="bold"
          font-style="normal">
          More Events
        </mj-button>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Footer Links -->
    <mj-section
      padding-top="32px"
      padding-bottom="16px"
      padding-left="24px"
      padding-right="24px"
      background-color="#F3F3F3">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32"><u>Link 1</u> | <u>Link 2</u> | <u>Link 3</u> | <u>Link 4</u> | <u>Link 5</u></span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Footer Social -->
    <mj-section
      padding-top="0px"
      padding-bottom="32px"
      padding-left="24px"
      padding-right="24px"
      background-color="#F3F3F3">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
        </mj-text>
        <mj-social
          font-size="12px"
          border-radius="50%"
          mode="horizontal"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
          <mj-social-element border-radius="50%" icon-size="32px" name="workvivo-noshare" src="${blob_url}/xmwrgbcr-image/kwwbf659-workvivo-icon.png" background-color="#9966F5"></mj-social-element>
          <mj-social-element border-radius="50%" icon-size="32px" name="twitter-noshare" src="${blob_url}/xmwrgbcr-image/kwwcupmb-twitter-icon.png" background-color="#000000"></mj-social-element>
          <mj-social-element border-radius="50%" icon-size="32px" name="linkedin-noshare" src="${blob_url}/xmwrgbcr-image/kwwcuq26-linkedin-icon.png" background-color="#0A66C2"></mj-social-element>
        </mj-social>
      </mj-column>
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
        </mj-text>
        <mj-social
          font-size="12px"
          border-radius="50%"
          mode="horizontal"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
          <mj-social-element border-radius="50%" icon-size="32px" name="workvivo-noshare" src="${blob_url}/xmwrgbcr-image/kwwbf659-workvivo-icon.png" background-color="#9966F5"></mj-social-element>
          <mj-social-element border-radius="50%" icon-size="32px" name="twitter-noshare" src="${blob_url}/xmwrgbcr-image/kwwcupmb-twitter-icon.png" background-color="#000000"></mj-social-element>
          <mj-social-element border-radius="50%" icon-size="32px" name="linkedin-noshare" src="${blob_url}/xmwrgbcr-image/kwwcuq26-linkedin-icon.png" background-color="#0A66C2"></mj-social-element>
        </mj-social>
      </mj-column>
    </mj-section>

  </mj-body>
</mjml>`,
  [GALLERY_SCHEMA.PREVIEW]: `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    body { margin: 0; padding: 0; }
    table, td { border-collapse: collapse; }
    img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
    p { display: block; margin: 13px 0; }
    p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
    ul, ol { margin-block-start: 0; margin-block-end: 0; padding-block-start: 0; padding-block-end: 0; Margin: 0; }
    a { color: inherit !important; text-decoration: underline; }
    @media only screen and (max-width:479px) {
      .mobile-stack-gap { padding-bottom: 24px !important; }
      .mobile-no-left-pad td { padding-left: 0px !important; }
      .mobile-img-no-pad table table { width: 100% !important; }
      .mobile-img-no-pad table td { width: 100% !important; }
    }
  </style>
</head>
<body style="word-spacing:normal;background-color:#F3F3F3;">
  <div style="background-color:#F3F3F3;">

    <!-- Header -->
    <div style="background:#0053E2;background-color:#0053E2;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0053E2;background-color:#0053E2;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:32px;padding-bottom:32px;padding-left:24px;padding-right:24px;text-align:center;">
              <div class="mobile-stack-gap" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:36%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;margin:0 auto;">
                          <tbody>
                            <tr>
                              <td style="width:100%;">
                                <img src="${blob_url}/templateeditortestteam-image/WMT-Wordmark-Standard-White-RGB.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100%" height="auto" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mobile-no-left-pad" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:64%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:24px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:18px;line-height:1.5;text-align:center;color:#ffffff;">
                          <p style="text-align:center"><span style="font-size:18px"><span style="color:#ffffff">Official headlines from the Home Office</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Hero Image -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:600px;">
                                <img src="${imgPlaceholderHero}" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Feature Article -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:32px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:16px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:20px;line-height:1.4;text-align:left;color:#2E2F32;">
                          <p><strong><span style="font-size:20px"><span style="color:#2E2F32">Headline Goes Here</span></span></strong></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:16px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eu feugiat pretium nibh ipsum consequat nisl vel pretium. Dignissim enim sit amet venenatis urna cursus.</span></span></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:24px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#0053E2" role="presentation" style="border:none;border-radius:1000px;cursor:auto;font-style:normal;height:32px;background:#0053E2;" valign="middle">
                                <p style="display:inline-block;background:#0053E2;color:#ffffff;font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;font-style:normal;font-weight:bold;line-height:120%;margin:0;text-decoration:none;padding:5px 16px;border-radius:1000px;">Read more</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <p style="border-top:solid 1px #E3E4E5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Article Row 1 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:24px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div class="mobile-stack-gap mobile-img-no-pad" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:29%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:100%;">
                                <img src="${imgPlaceholderArticle}" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100%" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mobile-no-left-pad" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:71%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:24px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:18px;line-height:1.4;text-align:left;color:#2E2F32;">
                          <p><strong><span style="font-size:18px"><span style="color:#2E2F32">Section heading goes here</span></span></strong></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:24px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></span></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:19px;padding-left:24px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#0053E2" role="presentation" style="border:none;border-radius:1000px;cursor:auto;font-style:normal;height:32px;background:#0053E2;" valign="middle">
                                <p style="display:inline-block;background:#0053E2;color:#ffffff;font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;font-style:normal;font-weight:bold;line-height:120%;margin:0;text-decoration:none;padding:5px 16px;border-radius:1000px;">Read more</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Article Row 2 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:24px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div class="mobile-stack-gap mobile-img-no-pad" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:29%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:100%;">
                                <img src="${imgPlaceholderArticle}" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100%" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mobile-no-left-pad" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:71%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:24px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:18px;line-height:1.4;text-align:left;color:#2E2F32;">
                          <p><strong><span style="font-size:18px"><span style="color:#2E2F32">Section heading goes here</span></span></strong></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:24px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></span></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:19px;padding-left:24px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#0053E2" role="presentation" style="border:none;border-radius:1000px;cursor:auto;font-style:normal;height:32px;background:#0053E2;" valign="middle">
                                <p style="display:inline-block;background:#0053E2;color:#ffffff;font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;font-style:normal;font-weight:bold;line-height:120%;margin:0;text-decoration:none;padding:5px 16px;border-radius:1000px;">Read more</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Article Row 3 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:24px;padding-bottom:24px;padding-left:24px;padding-right:24px;text-align:center;">
              <div class="mobile-stack-gap mobile-img-no-pad" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:29%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:100%;">
                                <img src="${imgPlaceholderArticle}" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100%" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mobile-no-left-pad" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:71%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:24px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:18px;line-height:1.4;text-align:left;color:#2E2F32;">
                          <p><strong><span style="font-size:18px"><span style="color:#2E2F32">Section heading goes here</span></span></strong></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:24px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></span></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:19px;padding-left:24px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#0053E2" role="presentation" style="border:none;border-radius:1000px;cursor:auto;font-style:normal;height:32px;background:#0053E2;" valign="middle">
                                <p style="display:inline-block;background:#0053E2;color:#ffffff;font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;font-style:normal;font-weight:bold;line-height:120%;margin:0;text-decoration:none;padding:5px 16px;border-radius:1000px;">Read more</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Blue Feature -->
    <div style="background:#0053E2;background-color:#0053E2;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0053E2;background-color:#0053E2;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;text-align:center;">
              <div class="mobile-img-no-pad" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:31%;background-color:#0053E2;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;background-color:#0053E2;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="background-color:#0053E2;font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;width:100%;">
                          <tbody>
                            <tr>
                              <td style="width:100%;">
                                <img src="${imgPlaceholderFeature}" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100%" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:69%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:24px;padding-bottom:8px;padding-left:24px;padding-right:24px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:18px;line-height:1.4;text-align:left;color:#ffffff;">
                          <p><strong><span style="font-size:18px"><span style="color:#ffffff">Section heading goes here</span></span></strong></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:24px;padding-left:24px;padding-right:24px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#ffffff;">
                          <p><span style="font-size:16px"><span style="color:#ffffff">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- White Gap -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:24px;padding-bottom:0px;padding-left:0px;padding-right:0px;text-align:center;"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- In the News -->
    <div style="background:#E9F1FE;background-color:#E9F1FE;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#E9F1FE;background-color:#E9F1FE;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:24px;padding-bottom:24px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><strong><span style="font-size:18px"><span style="color:#2E2F32">In the News</span></span></strong></p>
                          <ul>
                            <li><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</span></span></li>
                            <li><span style="font-size:16px"><span style="color:#2E2F32">Accumsan sit amet nulla facilisi morbi.</span></span></li>
                            <li><span style="font-size:16px"><span style="color:#2E2F32">Nisi vitae suscipit tellus mauris a diam maecenas sed.</span></span></li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Upcoming Events Title -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:32px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:20px;line-height:1.4;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><strong><span style="font-size:20px"><span style="color:#2E2F32">Upcoming Events</span></span></strong></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Event Divider 1 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <p style="border-top:solid 1px #E3E4E5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Event Row 1 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:25%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><strong><span style="font-size:16px"><span style="color:#2E2F32">Date</span></span></strong></p>
                          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32">Time</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:48%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><strong><span style="font-size:16px"><span style="color:#2E2F32">Event name</span></span></strong></p>
                          <p><span style="font-size:14px"><span style="color:#2E2F32">Event location</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:27%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="right" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:right;color:#2E2F32;">
                          <p style="text-align:right"><span style="font-size:16px"><span style="color:#2E2F32"><u>Interested &gt;</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Event Divider 2 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <p style="border-top:solid 1px #E3E4E5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Event Row 2 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:25%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><strong><span style="font-size:16px"><span style="color:#2E2F32">Date</span></span></strong></p>
                          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32">Time</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:48%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><strong><span style="font-size:16px"><span style="color:#2E2F32">Event name</span></span></strong></p>
                          <p><span style="font-size:14px"><span style="color:#2E2F32">Event location</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:27%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="right" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:right;color:#2E2F32;">
                          <p style="text-align:right"><span style="font-size:16px"><span style="color:#2E2F32"><u>Interested &gt;</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Event Divider 3 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <p style="border-top:solid 1px #E3E4E5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Event Row 3 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:25%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><strong><span style="font-size:16px"><span style="color:#2E2F32">Date</span></span></strong></p>
                          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32">Time</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:48%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><strong><span style="font-size:16px"><span style="color:#2E2F32">Event name</span></span></strong></p>
                          <p><span style="font-size:14px"><span style="color:#2E2F32">Event location</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:27%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="right" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:right;color:#2E2F32;">
                          <p style="text-align:right"><span style="font-size:16px"><span style="color:#2E2F32"><u>Interested &gt;</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Event Divider 4 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <p style="border-top:solid 1px #E3E4E5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- More Events -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:24px;padding-bottom:24px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:16px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#0053E2" role="presentation" style="border:none;border-radius:1000px;cursor:auto;font-style:normal;height:32px;background:#0053E2;" valign="middle">
                                <p style="display:inline-block;background:#0053E2;color:#ffffff;font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;font-style:normal;font-weight:bold;line-height:120%;margin:0;text-decoration:none;padding:5px 5px;border-radius:1000px;">More Events</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Footer Links -->
    <div style="background:#F3F3F3;background-color:#F3F3F3;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#F3F3F3;background-color:#F3F3F3;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:32px;padding-bottom:16px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32"><u>Link 1</u> | <u>Link 2</u> | <u>Link 3</u> | <u>Link 4</u> | <u>Link 5</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Footer Social -->
    <div style="background:#F3F3F3;background-color:#F3F3F3;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#F3F3F3;background-color:#F3F3F3;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:0px;padding-bottom:32px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:50%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#9966F5;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img src="${blob_url}/xmwrgbcr-image/kwwbf659-workvivo-icon.png" style="border-radius:50%;display:block;" width="32" height="auto" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img src="${blob_url}/xmwrgbcr-image/kwwcupmb-twitter-icon.png" style="border-radius:50%;display:block;" width="32" height="auto" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0A66C2;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img src="${blob_url}/xmwrgbcr-image/kwwcuq26-linkedin-icon.png" style="border-radius:50%;display:block;" width="32" height="auto" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:50%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#9966F5;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img src="${blob_url}/xmwrgbcr-image/kwwbf659-workvivo-icon.png" style="border-radius:50%;display:block;" width="32" height="auto" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img src="${blob_url}/xmwrgbcr-image/kwwcupmb-twitter-icon.png" style="border-radius:50%;display:block;" width="32" height="auto" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0A66C2;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img src="${blob_url}/xmwrgbcr-image/kwwcuq26-linkedin-icon.png" style="border-radius:50%;display:block;" width="32" height="auto" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</body>
</html>`,
};
export default General;
